import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Formik, Form, FieldArray } from "formik";
import { useDispatch, useSelector } from "react-redux";
import CustomField from "components/common/CustomField";
import CustomLabel from "components/common/CustomLabel";
import DetailsPageTitle from "components/common/DetailsPageTitle";
import FormButtons from "components/common/FormButtons";
import SingleSelect from "components/common/SingleSelect";
import { updatecashback, getcashbacklist } from "store/actions/couponAction";
import { createCashbackValues } from "components/constants/InitialFormValues";
import MonthField from "components/common/MonthField";
import { createCashbackSchema } from "components/common/Validation";
import { showAlert } from "store/reducers/alertReducer";
import { useNavigate } from "react-router-dom";
import Spinners from "components/common/Spinners";
import { percentageOptions } from "components/constants/DropdownOptions";
const CashBack = ({ mode }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, loading, cashbackList } = useSelector(
    (state) => state.Coupons
  );
  const [formValues, setFormValues] = useState(createCashbackValues);
  const [meeingroomformValues, setmeeingroomformValues] =
    useState(createCashbackValues);
  useEffect(() => {
    const getDetails = () => {
      dispatch(getcashbacklist());
    };
    getDetails();
  }, []);

  useEffect(() => {
    if (cashbackList) {
      const { title, titleAr, cycleExpiredIn, levels, promoText } =
        cashbackList[0] || {};
      setFormValues((prevValues) => ({
        ...prevValues,
        title,
        titleAr,
        cycleExpiredIn,
        promoText: promoText || [],
        levels: levels?.map((level) => ({
          title: level.title,
          titleAr: level.titleAr,
          value: level.value?.toString() || "",
          cashbackPercentage: level.cashbackPercentage?.toString() || "",
          expiredIn: level.expiredIn?.toString() || "",
        })) || [
          {
            title: "",
            titleAr: "",
            value: "",
            cashbackPercentage: "",
            expiredIn: "",
          },
        ],
      }));
    }
  }, [cashbackList]);

  useEffect(() => {
    if (cashbackList) {
      const { title, titleAr, cycleExpiredIn, levels, promoText } =
        cashbackList[1] || {};

      setmeeingroomformValues((prevValues) => ({
        ...prevValues,
        title,
        titleAr,
        cycleExpiredIn,
        promoText: promoText || [],
        levels: levels?.map((level) => ({
          title: level.title,
          titleAr: level.titleAr,
          value: level.value?.toString() || "",
          cashbackPercentage: level.cashbackPercentage?.toString() || "",
          expiredIn: level.expiredIn?.toString() || "",
        })) || [
          {
            title: "",
            titleAr: "",
            value: "",
            cashbackPercentage: "",
            expiredIn: "",
          },
        ],
      }));
    }
  }, [cashbackList]);

  const handleRoomSubmit = async (values, { setSubmitting }, index = 0) => {
    const cashbackId = cashbackList[index]?._id;

    const requestData = {
      id: cashbackId,
      title: values.title,
      titleAr: values.titleAr,
      promoText: values.promoText
        .filter((text) => text.description || text.descriptionAr)
        .map((text) => ({
          description: text.description || "",
          descriptionAr: text.descriptionAr || "",
        })),
      cycleExpiredIn: Number(values.cycleExpiredIn),
      levels: values.levels.map((level) => ({
        title: level.title,
        titleAr: level.titleAr,
        value: Number(level.value),
        cashbackPercentage: Number(level.cashbackPercentage),
        expiredIn: Number(level.expiredIn),
      })),
    };

    try {
      const action = await dispatch(updatecashback(requestData));
      const { statusCode, success, message } = action?.payload || {};
      if (statusCode === 200 && success) {
        dispatch(showAlert({ text: message, type: "success" }));
      } else {
        dispatch(showAlert({ text: message, type: "error" }));
      }
    } catch (error) {
      console.error("Error updating cashback:", error);
      dispatch(
        showAlert({
          text: "An error occurred. Please try again.",
          type: "error",
        })
      );
    } finally {
      setSubmitting(false);
    }
  };
 
  const monthData = [
    { name: "1 Month", value: "1" },
    { name: "2 Months", value: "2" },
    { name: "3 Months", value: "3" },
    { name: "4 Months", value: "4" },
    { name: "5 Months", value: "5" },
    { name: "6 Months", value: "6" },
    { name: "7 Months", value: "7" },
    { name: "8 Months", value: "8" },
    { name: "9 Months", value: "9" },
    { name: "10 Months", value: "10" },
    { name: "11 Months", value: "11" },
    { name: "12 Months", value: "12" },
  ];

  const addPromoText = (values, setFieldValue) => {
    setFieldValue("promoText", [
      ...values.promoText,
      { description: "", descriptionAr: "" },
    ]);
  };

  const removePromoText = (values, setFieldValue, index) => {
    const newPromoTexts = [...values.promoText];
    newPromoTexts.splice(index, 1);
    setFieldValue("promoText", newPromoTexts);
  };

  const addLevel = (values, setFieldValue) => {
    setFieldValue("levels", [
      ...values.levels,
      {
        title: "",
        titleAr: "",
        value: "",
        cashbackPercentage: "",
        expiredIn: "",
      },
    ]);
  };

  const removeLevel = (values, setFieldValue, index) => {
    const newLevels = [...values.levels];
    newLevels.splice(index, 1);
    setFieldValue("levels", newLevels);
  };

  return (
    <div className="page-content common_page add_workshop_page">
      {loading ? (
        <Spinners />
      ) : (
        <Container fluid>
          <Row>
            <DetailsPageTitle title={t("Cashback")} />
            <Formik
              initialValues={formValues}
              enableReinitialize={true}
              onSubmit={(values, { setSubmitting }) =>
                handleRoomSubmit(values, { setSubmitting }, 0)
              }
              validationSchema={createCashbackSchema}
            >
              {({
                values,
                handleChange,
                setFieldValue,
                isSubmitting,
                errors,
                touched,
              }) => (
                <Form>
                  <Row className="common_wrapper">
                    <Col lg={12} style={{ marginTop: 21 }}>
                      <div className="bg_white br_14 p_23_30">
                        <h2 className="fs_20 mb-4">
                          {t("Workspace Cashback")}
                        </h2>
                        <Row>
                          <div className="mb-4 text-muted d-flex align-items-center">
                            <p>
                              {t("Cycle expires at the end of each")}{" "}
                              <strong>{t("month")}</strong>
                            </p>
                            <Col style={{ marginLeft: "10px" }} lg={2}>
                              {" "}
                              <MonthField
                                value={values.cycleExpiredIn}
                                onChange={({ value }) => {
                                  setFieldValue("cycleExpiredIn", value);
                                }}
                              />
                            </Col>
                          </div>
                        </Row>
                        {/* Title Fields */}
                        <Row>
                          <Col lg={6}>
                            <div className="form_field">
                              <CustomLabel
                                label={t("Cashback English Progress Bar Title")}
                              />
                              <CustomField
                                name="title"
                                type="text"
                                placeholder={t("Enter English Title")}
                                touched={touched.title}
                                errors={errors.title}
                              />
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="form_field">
                              <CustomLabel
                                label={t("Cashback Arabic Progress Bar Title")}
                              />
                              <CustomField
                                name="titleAr"
                                type="text"
                                placeholder={t("Enter Arabic Title")}
                                touched={touched.titleAr}
                                errors={errors.titleAr}
                                isArabic={true}
                              />
                            </div>
                          </Col>
                        </Row>

                        {/* Promotional Texts */}
                        <FieldArray
                          name="promoText"
                          render={(arrayHelpers) => (
                            <>
                              {values.promoText.map((promo, index) => (
                                <Row key={index}>
                                  <Col lg={6}>
                                    <div className="form_field">
                                      <CustomLabel
                                        label={`${t(
                                          "Promotional English Text"
                                        )} ${index + 1}`}
                                      />
                                      <CustomField
                                        name={`promoText[${index}].description`}
                                        type="text"
                                        placeholder={t(
                                          "Enter English Promotional Text"
                                        )}
                                        touched={touched.description}
                                        errors={errors.description}
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={6}>
                                    <div className="form_field">
                                      <CustomLabel
                                        label={`${t(
                                          "Promotional Arabic Text"
                                        )} ${index + 1}`}
                                      />
                                      <CustomField
                                        name={`promoText[${index}].descriptionAr`}
                                        type="text"
                                        placeholder={t(
                                          "Enter Arabic Promotional Text"
                                        )}
                                        touched={touched.descriptionAr}
                                        errors={errors.descriptionAr}
                                        isArabic={true}
                                      />
                                    </div>
                                  </Col>
                                  <Col
                                    lg={2}
                                    className="d-flex align-items-end"
                                  >
                                    {index > 0 && (
                                      <button
                                        type="button"
                                        className="cancel_btn"
                                        onClick={() =>
                                          removePromoText(
                                            values,
                                            setFieldValue,
                                            index
                                          )
                                        }
                                      >
                                        {t("Remove")}
                                      </button>
                                    )}
                                  </Col>
                                </Row>
                              ))}

                              {/* Add New Promotional Text Button */}
                              <div className="g_end mt-4">
                                <button
                                  type="button"
                                  className="main_btn"
                                  onClick={() =>
                                    addPromoText(values, setFieldValue)
                                  }
                                >
                                  {t("Add New Promotional Text")}
                                </button>
                              </div>
                            </>
                          )}
                        />

                        {/* Cashback Levels */}
                        <FieldArray
                          name="levels"
                          render={(arrayHelpers) => (
                            <>
                              {values.levels.map((level, index) => (
                                <div
                                  className="level-section-container"
                                  style={{ marginTop: "24px" }}
                                  key={index}
                                >
                                  <Row>
                                    <h2 className="fs_20 mb-4">
                                      {t(`Cashback Level ${index + 1}`)}
                                    </h2>

                                    <Col lg={6}>
                                      <div className="form_field">
                                        <CustomLabel
                                          label={t("English Tooltip")}
                                        />
                                        <CustomField
                                          name={`levels[${index}].title`}
                                          type="text"
                                          placeholder={t(
                                            "Enter English Tooltip"
                                          )}
                                          touched={touched.title}
                                          errors={errors.title}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg={6}>
                                      <div className="form_field">
                                        <CustomLabel
                                          label={t("Arabic Tooltip")}
                                        />
                                        <CustomField
                                          name={`levels[${index}].titleAr`}
                                          type="text"
                                          placeholder={t(
                                            "Enter Arabic Tooltip"
                                          )}
                                          touched={touched.titleAr}
                                          errors={errors.titleAr}
                                          isArabic={true}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg={3}>
                                      <div className="form_field">
                                        <CustomLabel
                                          label={t("Cashback Percentage")}
                                          required
                                        />
                                        <SingleSelect
                                          name={`levels[${index}].cashbackPercentage`}
                                          options={percentageOptions}
                                          placeholder={t("15%")}
                                          handleSingleSelectChange={(
                                            selectedOption
                                          ) => {
                                            setFieldValue(
                                              `levels[${index}].cashbackPercentage`,
                                              selectedOption.value
                                            );
                                          }}
                                          value={
                                            values?.levels[index]
                                              ?.cashbackPercentage
                                          }
                                        />
                                        {errors.levels?.[index]
                                          ?.cashbackPercentage &&
                                          touched.levels?.[index]
                                            ?.cashbackPercentage && (
                                            <div
                                              className="text-danger"
                                              style={{
                                                fontSize: "0.875rem",
                                                marginTop: "0.25rem",
                                              }}
                                            >
                                              {t(
                                                errors.levels[index]
                                                  .cashbackPercentage
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    </Col>

                                    <Col lg={3}>
                                      <div className="form_field">
                                        <CustomLabel
                                          label={t("Number of Bookings")}
                                          required
                                        />
                                        <CustomField
                                          name={`levels[${index}].value`}
                                          type="number"
                                          placeholder={t(
                                            "Enter number of bookings"
                                          )}
                                          min="1"
                                          onChange={handleChange}
                                          value={values.levels[index].value}
                                          touched={
                                            touched.levels?.[index]?.value
                                          }
                                          error={errors.levels?.[index]?.value}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg={3}>
                                      <div className="form_field">
                                        <CustomLabel
                                          label={t("Expiration (months)")}
                                          required
                                        />
                                        <SingleSelect
                                          name={`levels[${index}].expiredIn`}
                                          options={monthData}
                                          placeholder={t("After Month")}
                                          handleSingleSelectChange={(
                                            selectedOption
                                          ) => {
                                            setFieldValue(
                                              `levels[${index}].expiredIn`,
                                              selectedOption?.value || ""
                                            );
                                          }}
                                          value={level.expiredIn}
                                        />
                                        {errors.levels?.[index]?.expiredIn &&
                                          touched.levels?.[index]
                                            ?.expiredIn && (
                                            <div
                                              className="text-danger"
                                              style={{
                                                fontSize: "0.875rem",
                                                marginTop: "0.25rem",
                                              }}
                                            >
                                              {t(
                                                errors.levels[index].expiredIn
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    </Col>

                                    <Col
                                      lg={2}
                                      className="d-flex align-items-center"
                                    >
                                      {index > 0 && (
                                        <button
                                          type="button"
                                          className="cancel_btn"
                                          onClick={() =>
                                            removeLevel(
                                              values,
                                              setFieldValue,
                                              index
                                            )
                                          }
                                        >
                                          {t("Remove Level")}
                                        </button>
                                      )}
                                    </Col>
                                  </Row>
                                </div>
                              ))}

                              {/* Add New Level Button */}
                              <div className="g_end mt-4">
                                <button
                                  type="button"
                                  className="main_btn"
                                  onClick={() =>
                                    addLevel(values, setFieldValue)
                                  }
                                >
                                  {t("Add New Level")}
                                </button>
                              </div>
                            </>
                          )}
                        />
                      </div>
                    </Col>

                    {/* Form Buttons */}
                    <Row className="px-0 my-4">
                      <FormButtons
                        isLoading={isLoading}
                        addBtnText={t("Save")}
                      />
                    </Row>
                  </Row>
                </Form>
              )}
            </Formik>
            <Formik
              initialValues={meeingroomformValues}
              enableReinitialize={true}
              onSubmit={(values, { setSubmitting }) =>
                handleRoomSubmit(values, { setSubmitting }, 1)
              }
              validationSchema={createCashbackSchema}
            >
              {({
                values,
                handleChange,
                setFieldValue,
                isSubmitting,
                errors,
                touched,
              }) => (
                <Form>
                  <Row className="common_wrapper">
                    <Col lg={12} style={{ marginTop: 21 }}>
                      <div className="bg_white br_14 p_23_30">
                        <h2 className="fs_20 mb-4">
                          {t("Meeting Room Cashback")}
                        </h2>
                        <Row>
                          <div className="mb-4 text-muted d-flex align-items-center">
                            <p>
                              {t("Cycle expires at the end of each")}{" "}
                              <strong>{t("month")}</strong>
                            </p>
                            <Col style={{ marginLeft: "10px" }} lg={2}>
                              {" "}
                              <MonthField
                                value={values.cycleExpiredIn}
                                onChange={({ value }) => {
                                  setFieldValue("cycleExpiredIn", value);
                                }}
                              />
                            </Col>
                          </div>
                        </Row>
                        {/* Title Fields */}
                        <Row>
                          <Col lg={6}>
                            <div className="form_field">
                              <CustomLabel
                                label={t("Cashback English Progress Bar Title")}
                              />
                              <CustomField
                                name="title"
                                type="text"
                                placeholder={t("Enter English Title")}
                                touched={touched.title}
                                errors={errors.title}
                              />
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="form_field">
                              <CustomLabel
                                label={t("Cashback Arabic Progress Bar Title")}
                              />
                              <CustomField
                                name="titleAr"
                                type="text"
                                placeholder={t("Enter Arabic Title")}
                                touched={touched.titleAr}
                                errors={errors.titleAr}
                                isArabic={true}
                              />
                            </div>
                          </Col>
                        </Row>

                        {/* Promotional Texts */}
                        <FieldArray
                          name="promoText"
                          render={(arrayHelpers) => (
                            <>
                              {values.promoText.map((promo, index) => (
                                <Row key={index}>
                                  <Col lg={6}>
                                    <div className="form_field">
                                      <CustomLabel
                                        label={`${t(
                                          "Promotional English Text"
                                        )} ${index + 1}`}
                                      />
                                      <CustomField
                                        name={`promoText[${index}].description`}
                                        type="text"
                                        placeholder={t(
                                          "Enter English Promotional Text"
                                        )}
                                        touched={touched.description}
                                        errors={errors.description}
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={6}>
                                    <div className="form_field">
                                      <CustomLabel
                                        label={`${t(
                                          "Promotional Arabic Text"
                                        )} ${index + 1}`}
                                      />
                                      <CustomField
                                        name={`promoText[${index}].descriptionAr`}
                                        type="text"
                                        placeholder={t(
                                          "Enter Arabic Promotional Text"
                                        )}
                                        touched={touched.descriptionAr}
                                        errors={errors.descriptionAr}
                                        isArabic={true}
                                      />
                                    </div>
                                  </Col>
                                  <Col
                                    lg={2}
                                    className="d-flex align-items-end"
                                  >
                                    {index > 0 && (
                                      <button
                                        type="button"
                                        className="cancel_btn"
                                        onClick={() =>
                                          removePromoText(
                                            values,
                                            setFieldValue,
                                            index
                                          )
                                        }
                                      >
                                        {t("Remove")}
                                      </button>
                                    )}
                                  </Col>
                                </Row>
                              ))}

                              {/* Add New Promotional Text Button */}
                              <div className="g_end mt-4">
                                <button
                                  type="button"
                                  className="main_btn"
                                  onClick={() =>
                                    addPromoText(values, setFieldValue)
                                  }
                                >
                                  {t("Add New Promotional Text")}
                                </button>
                              </div>
                            </>
                          )}
                        />

                        {/* Cashback Levels */}
                        <FieldArray
                          name="levels"
                          render={(arrayHelpers) => (
                            <>
                              {values.levels.map((level, index) => (
                                <div
                                  className="level-section-container"
                                  style={{ marginTop: "24px" }}
                                  key={index}
                                >
                                  <Row>
                                    <h2 className="fs_20 mb-4">
                                      {t(`Cashback Level ${index + 1}`)}
                                    </h2>

                                    <Col lg={6}>
                                      <div className="form_field">
                                        <CustomLabel
                                          label={t("English Tooltip")}
                                        />
                                        <CustomField
                                          name={`levels[${index}].title`}
                                          type="text"
                                          placeholder={t(
                                            "Enter English Tooltip"
                                          )}
                                          touched={touched.title}
                                          errors={errors.title}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg={6}>
                                      <div className="form_field">
                                        <CustomLabel
                                          label={t("Arabic Tooltip")}
                                        />
                                        <CustomField
                                          name={`levels[${index}].titleAr`}
                                          type="text"
                                          placeholder={t(
                                            "Enter Arabic Tooltip"
                                          )}
                                          touched={touched.titleAr}
                                          errors={errors.titleAr}
                                          isArabic={true}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg={3}>
                                      <div className="form_field">
                                        <CustomLabel
                                          label={t("Expiration (months)")}
                                          required
                                        />
                                        <SingleSelect
                                          name={`levels[${index}].cashbackPercentage`}
                                          options={percentageOptions}
                                          placeholder={t("15%")}
                                          handleSingleSelectChange={(
                                            selectedOption
                                          ) => {
                                            setFieldValue(
                                              `levels[${index}].cashbackPercentage`,
                                              selectedOption.value
                                            );
                                          }}
                                          value={
                                            values?.levels[index]
                                              ?.cashbackPercentage
                                          }
                                        />
                                        {errors.levels?.[index]
                                          ?.cashbackPercentage &&
                                          touched.levels?.[index]
                                            ?.cashbackPercentage && (
                                            <div
                                              className="text-danger"
                                              style={{
                                                fontSize: "0.875rem",
                                                marginTop: "0.25rem",
                                              }}
                                            >
                                              {t(
                                                errors.levels[index]
                                                  .cashbackPercentage
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    </Col>

                                    <Col lg={3}>
                                      <div className="form_field">
                                        <CustomLabel
                                          label={t("Number of Hours")}
                                          required
                                        />
                                        <CustomField
                                          name={`levels[${index}].value`}
                                          type="number"
                                          placeholder={t(
                                            "Enter number of bookings"
                                          )}
                                          min="1"
                                          onChange={handleChange}
                                          value={values.levels[index].value}
                                          touched={
                                            touched.levels?.[index]?.value
                                          }
                                          error={errors.levels?.[index]?.value}
                                        />
                                      </div>
                                    </Col>

                                    <Col lg={3}>
                                      <div className="form_field">
                                        <CustomLabel
                                          label={t("Expiration (months)")}
                                          required
                                        />
                                        <SingleSelect
                                          name={`levels[${index}].expiredIn`}
                                          options={monthData}
                                          placeholder={t("After Month")}
                                          handleSingleSelectChange={(
                                            selectedOption
                                          ) => {
                                            setFieldValue(
                                              `levels[${index}].expiredIn`,
                                              selectedOption?.value || ""
                                            );
                                          }}
                                          value={level.expiredIn}
                                        />
                                        {errors.levels?.[index]?.expiredIn &&
                                          touched.levels?.[index]
                                            ?.expiredIn && (
                                            <div
                                              className="text-danger"
                                              style={{
                                                fontSize: "0.875rem",
                                                marginTop: "0.25rem",
                                              }}
                                            >
                                              {t(
                                                errors.levels[index].expiredIn
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    </Col>

                                    <Col
                                      lg={2}
                                      className="d-flex align-items-center"
                                    >
                                      {index > 0 && (
                                        <button
                                          type="button"
                                          className="cancel_btn"
                                          onClick={() =>
                                            removeLevel(
                                              values,
                                              setFieldValue,
                                              index
                                            )
                                          }
                                        >
                                          {t("Remove Level")}
                                        </button>
                                      )}
                                    </Col>
                                  </Row>
                                </div>
                              ))}

                              {/* Add New Level Button */}
                              <div className="g_end mt-4">
                                <button
                                  type="button"
                                  className="main_btn"
                                  onClick={() =>
                                    addLevel(values, setFieldValue)
                                  }
                                >
                                  {t("Add New Level")}
                                </button>
                              </div>
                            </>
                          )}
                        />
                      </div>
                    </Col>

                    {/* Form Buttons */}
                    <Row className="px-0 my-4">
                      <FormButtons
                        isLoading={isLoading}
                        addBtnText={t("Save")}
                      />
                    </Row>
                  </Row>
                </Form>
              )}
            </Formik>
          </Row>
        </Container>
      )}
    </div>
  );
};

export default CashBack;
